import styled from "styled-components";
import { colorPalette, typeScale } from "../../../../utils/theme";

export const StyledContainer = styled.div`
  margin-top: 60px;

  @media (max-width: 767.98px) {
    margin-top: 0;
  }
`;

export const BreadcrumbItem = styled.p`
  margin: 0;
  color: ${colorPalette.blue500};
  ${typeScale.bodySMMain}
`;

export const Divider = styled.div`
  width: 100%;
  margin-top: 24px;
  margin-bottom: 24px;
  border: 1px solid ${colorPalette.blue200};
`;

export const BottomContainer = styled.div`
  padding-bottom: 60px;

  @media (max-width: 767.98px) {
    padding-bottom: 30px;
  }
`;
